import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import submit from './submit';
import messages from '../../../locale/jsonMessages';
import Loader from '../../Loader/Loader';
import fetch from '../../../core/fetch';
import logo from '/public/PaymentGateway/pawapay.svg';
import cs from '../../commonStyle.css';
import s from '../Payout.css';

const validate = values => {
  const errors = {};
  if (!values.payEmail || !/^\+?[0-9]{8,15}$/.test(values.payEmail.replace(/\s/g, ''))) errors.payEmail = messages.required;
  if (!values.address1) errors.address1 = messages.required;
  if (!values.country || !/^[A-Za-z]{3}$/.test(values.country)) errors.country = messages.required;
  if (!values.currency) errors.currency = messages.required;
  return errors;
};

class PawaPay extends Component {
  state = { countries: [], loadingOptions: true, optionsError: '' };

  componentDidMount() {
    fetch('/pawapay/payout-options', { credentials: 'include' })
      .then(response => response.json())
      .then(result => {
        if (result.status !== 200 || !result.countries?.length) throw new Error(result.errorMessage || 'Aucun pays PawaPay actif pour les reversements.');
        const country = result.countries.find(item => item.country === result.recommendedCountry) || result.countries[0];
        const currency = country.currencies[0];
        this.setState({ countries: result.countries, loadingOptions: false, optionsError: '' });
        this.props.change('country', country.country);
        this.props.change('currency', currency.currency);
        this.props.change('address1', currency.providers[0]?.provider || '');
      })
      .catch(error => this.setState({ loadingOptions: false, optionsError: error.message }));
  }

  selectCountry = value => {
    const country = this.state.countries.find(item => item.country === value);
    const currency = country?.currencies[0];
    this.props.change('currency', currency?.currency || '');
    this.props.change('address1', currency?.providers[0]?.provider || '');
  };

  selectCurrency = value => {
    const country = this.state.countries.find(item => item.country === this.props.country);
    const currency = country?.currencies.find(item => item.currency === value);
    this.props.change('address1', currency?.providers[0]?.provider || '');
  };

  renderField = ({ input, label, placeholder, meta: { touched, error } }) => <FormGroup className={cs.noMargin}>
    <label className='commonLabelText'>{label}<sup className='isRequiredStar'>*</sup></label>
    <FormControl {...input} className='commonInputField' placeholder={placeholder} />
    {touched && error && <span className={cs.errorMessage}>{this.props.intl.formatMessage(error)}</span>}
  </FormGroup>;

  renderSelect = ({ input, label, children, meta: { touched, error } }) => <FormGroup className={cs.noMargin}>
    <label className='commonLabelText'>{label}<sup className='isRequiredStar'>*</sup></label>
    <FormControl componentClass='select' {...input} className='commonSelectField'>{children}</FormControl>
    {touched && error && <span className={cs.errorMessage}>{this.props.intl.formatMessage(error)}</span>}
  </FormGroup>;

  render() {
    const { handleSubmit, pristine, previousPage, submitting, payoutLoading, country, currency } = this.props;
    const { formatMessage } = this.props.intl;
    const selectedCountry = this.state.countries.find(item => item.country === country);
    const selectedCurrency = selectedCountry?.currencies.find(item => item.currency === currency);
    return <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
      <form onSubmit={handleSubmit(submit)}>
        <h2 className={cx(cs.commonTotalText, cs.paddingBottom4)}>{formatMessage(messages.addPayout)}</h2>
        <img src={logo} height='48' className={cs.spaceBottom2} alt='PawaPay' />
        <p className={cx(cs.commonMediumText, cs.paddingBottom3)}>Ajoutez le portefeuille Mobile Money qui recevra vos reversements PawaPay.</p>
        <div className='oneColumnGrid'>
          <Field name='payEmail' component={this.renderField} label='Numéro Mobile Money (format international)' placeholder='241XXXXXXXX' />
          {this.state.loadingOptions && <Loader />}
          {this.state.optionsError && <p role='alert' className={cs.errorMessage}>{this.state.optionsError}</p>}
          <Field name='country' component={this.renderSelect} label='Pays' onChange={(event, value) => this.selectCountry(value)}>
            {this.state.countries.map(item => <option key={item.country} value={item.country}>{(typeof item.displayName === 'string' ? item.displayName : (item.displayName?.fr || item.displayName?.en)) || item.country}</option>)}
          </Field>
          <Field name='currency' component={this.renderSelect} label='Devise' onChange={(event, value) => this.selectCurrency(value)}>
            {(selectedCountry?.currencies || []).map(item => <option key={item.currency} value={item.currency}>{item.currency}</option>)}
          </Field>
          <Field name='address1' component={this.renderSelect} label='Fournisseur Mobile Money'>
            {(selectedCurrency?.providers || []).map(item => <option key={item.provider} value={item.provider}>{item.displayName || item.provider}</option>)}
          </Field>
        </div>
        <div className={cx('doubleBtnFlexEnd', cs.spaceTop4)}>
          <Button className={cs.btnPrimaryBorder} onClick={previousPage}><FormattedMessage {...messages.back} /></Button>
          <Loader type='button' buttonType='submit' label={formatMessage(messages.finish)} className={cx(cs.btnPrimary, 'loaderButtonFlex')}
            show={submitting || payoutLoading} disabled={pristine || submitting || payoutLoading || this.state.loadingOptions || Boolean(this.state.optionsError)} />
        </div>
      </form>
    </div>;
  }
}

PawaPay = reduxForm({ form: 'PayoutForm', destroyOnUnmount: false, forceUnregisterOnUnmount: true, validate })(PawaPay);
export default injectIntl(withStyles(cs, s)(connect(state => ({
  country: state.form?.PayoutForm?.values?.country,
  currency: state.form?.PayoutForm?.values?.currency,
  payoutLoading: state.reservation.payoutLoading
}))(PawaPay)));
